import dateformat from 'dateformat';

export const formatDate = (date) => dateformat(date, 'dd/mm/yyyy');
